import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text, TextButton } from 'wix-style-react';
import { useEnterpriseRefContext } from 'providers/EnterpriseContextProvider';
import s from './Faq.scss';

interface FaqAnswerProps {
  faqCode: string;
  isEnterpriseFaqs: boolean;
}

export const FaqAnswer: React.FC<FaqAnswerProps> = ({
  faqCode,
  isEnterpriseFaqs,
}) => {
  const answerKey = isEnterpriseFaqs
    ? `enterprise_plans.faq.answer.${faqCode}`
    : `faq.${faqCode}.answer`;
  const linkKey = isEnterpriseFaqs
    ? `enterprise_plans.faq.link.${faqCode}`
    : `faq.${faqCode}.link`;
  const { t } = useTranslation();
  const { scrollToRef } = useEnterpriseRefContext();

  return (
    <Text
      weight='normal'
      size='medium'
      tagName='p'
      className={s.answer}
      dataHook={`faq-answer-${faqCode}`}
      data-testid={`faq-answer-${faqCode}`}
    >
      {isEnterpriseFaqs && t(linkKey).includes('https') ? (
        <FaqAnswerLink answerKey={answerKey} link={linkKey} />
      ) : (
        <FaqAnswerCallback
          answerKey={answerKey}
          link={linkKey}
          callback={scrollToRef}
        />
      )}
    </Text>
  );
};

const FaqAnswerLink = ({ answerKey, link }) => {
  const { t } = useTranslation();
  return (
    <Trans i18nKey={answerKey} value={link}>
      {answerKey}
      <TextButton as='a' size='medium' target='_blank' href={t(link)}>
        {link}
      </TextButton>
    </Trans>
  );
};

const FaqAnswerCallback = ({ answerKey, link, callback }) => {
  return (
    <Trans i18nKey={answerKey} value={link}>
      {answerKey}
      <TextButton as='span' size='medium' onClick={callback}>
        {link}
      </TextButton>
    </Trans>
  );
};
